export default __webpack_public_path__ + "static/image-price-grid-card-5dddbd8749f133461bed13499aa09993.png";